import React from "react";
import { Pill, Reveal } from "./Reveal";
import { PillButton } from "./Kit";
import TalkFirst from "./TalkFirst";

const RULES = [
  [
    "One job first",
    "We fix the job your team repeats most before we touch anything else.",
  ],
  [
    "Your way, kept",
    "The tool learns your checklist. Your team doesn't relearn the job.",
  ],
  ["Read before write", "Nothing changes until a person approves it."],
  [
    "Say no early",
    "If a job isn't worth a tool, the check says so. So does the Audit.",
  ],
  [
    "Leave",
    "Every engagement ends with a tool you own and can run without us.",
  ],
];

// The About page below the definition: who builds it, the rules we work by, and the one first step.
export default function AboutStory() {
  return (
    <>
      <section className="px-5 pt-8 lg:pt-12" data-testid="founder">
        <div className="mx-auto grid max-w-[1400px] gap-8 border-t border-black/10 pt-10 lg:grid-cols-12 lg:pt-14">
          <div className="lg:col-span-4">
            <Pill>Who builds it</Pill>
          </div>
          <Reveal className="lg:col-span-8">
            <p className="nm-title max-w-[820px] text-[26px] leading-[1.15] sm:text-[38px]">
              I have designed products and interfaces since 2007. Since 2023 I
              have built tools that people and AI use together, and I run my own
              business on them. Nomus is that work, done for your team.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <span className="block h-14 w-14 shrink-0 overflow-hidden rounded-full bg-black">
                <img
                  src="/images/nomus-founder.jpg"
                  alt="Mariusz Czajkowski"
                  width="56"
                  height="56"
                  loading="lazy"
                  className="h-full w-full origin-[58%_38%] scale-[1.45] object-cover grayscale"
                />
              </span>
              <div className="text-[15px] leading-[1.35]">
                <p className="font-medium">Mariusz Czajkowski</p>
                <p className="opacity-50">Founder, Nomus · Warsaw</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="px-5 pt-24 lg:pt-36" data-testid="rules">
        <div className="mx-auto max-w-[1400px]">
          <Reveal>
            <h2 className="nm-title max-w-[900px] text-[30px] leading-[1.08] sm:text-[48px]">
              Five rules we work by.
            </h2>
          </Reveal>
          <ol className="mt-10 border-t border-black/10 lg:mt-14">
            {RULES.map(([name, text], i) => (
              <Reveal
                as="li"
                key={name}
                delay={i * 70}
                className="grid gap-1 border-b border-black/10 py-7 sm:py-9 lg:grid-cols-12 lg:gap-8"
              >
                <span className="hidden text-[12px] tabular-nums opacity-35 lg:col-span-1 lg:block lg:pt-2">
                  0{i + 1}
                </span>
                <p className="text-[22px] leading-[1.15] tracking-[-0.02em] sm:text-[28px] lg:col-span-4">
                  {name}
                </p>
                <p className="text-[18px] leading-[1.35] opacity-50 sm:text-[22px] lg:col-span-7">
                  {text}
                </p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="px-5 pt-20 lg:pt-28">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="nm-title text-[30px] leading-[1.05] sm:text-[44px]">
            Find the job worth fixing.
          </p>
          <div className="flex flex-wrap gap-3">
            <PillButton to="/scorecard" size="lg">
              Start the check
            </PillButton>
            <TalkFirst location="about_closing" tone="light" />
          </div>
        </div>
      </section>
    </>
  );
}
